<div class="container">
  <label for="cal">{{ 'CRM.LABEL.SHIFT_DATE' | translate }}:</label>
  <p-datepicker
    [showButtonBar]="true"
    inputId="cal"
    [(ngModel)]="value"
    [disabled]="isDisabled()"
    [clearButtonStyleClass]="'hideClearButton'"
    (onSelect)="onDateChange($event)"
    [autofocus]="false"
    class="cal"
  />
</div>
